import styled from 'styled-components';

// Base container
export const ContainerBase = styled.div`

`;
